module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-overview-box flex-grid flex-grid--reduced-bottom-margin-slight u-position-relative"
  }, [_c('div', {
    staticClass: "box u-d-flex flex-grid--wrap u-flex-wrap"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3766b940!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OverviewBox.vue
// module id = 1639
// module chunks = 0